import type { CommunityDetail } from 'models';
import { usePermissions } from 'permissions';
import { Card, Col, ContentWrapper, Row, withErrorBoundary } from 'ui';
import { ContentObjectFeed, CreateContentObjectTrigger, PinnedFeed } from 'features/feed';
import { Administrators } from '../components';

type P = {
  community: CommunityDetail;
};

const CommunityFeed = ({ community }: P) => {
  const { canCreateContentObject } = usePermissions();

  return (
    <ContentWrapper aside={<Administrators community={community} />}>
      <Row gutter={[0, 'ms']}>
        {canCreateContentObject({}) ? (
          <Col span={24}>
            <Card marginBottom={false}>
              <CreateContentObjectTrigger initialCommunity={community} />
            </Card>
          </Col>
        ) : null}
        <Col span={24}>
          <PinnedFeed communityId={community.id} />
        </Col>
        <Col span={24}>
          <ContentObjectFeed
            communityId={community.id}
            emptyState={{
              description: {
                subtitle: 'Subtitle',
                title: 'Title',
              },
            }}
            pinned={false}
          />
        </Col>
      </Row>
    </ContentWrapper>
  );
};

export default withErrorBoundary(CommunityFeed);
